var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHealthSafetyIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40.02,
    height: 40,
    rx: 8,
    fill: "#136DEC",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2322 29.7222C11.6975 29.7222 11.2397 29.5318 10.859 29.151C10.4782 28.7702 10.2878 28.3124 10.2878 27.7777V16.1111C10.2878 15.5763 10.4782 15.1186 10.859 14.7378C11.2397 14.357 11.6975 14.1666 12.2322 14.1666H16.1211V12.2222C16.1211 11.6874 16.3115 11.2297 16.6923 10.8489C17.0731 10.4681 17.5308 10.2777 18.0656 10.2777H21.9544C22.4892 10.2777 22.9469 10.4681 23.3277 10.8489C23.7085 11.2297 23.8989 11.6874 23.8989 12.2222V14.1666H27.7878C28.3225 14.1666 28.7803 14.357 29.161 14.7378C29.5418 15.1186 29.7322 15.5763 29.7322 16.1111V27.7777C29.7322 28.3124 29.5418 28.7702 29.161 29.151C28.7803 29.5318 28.3225 29.7222 27.7878 29.7222H12.2322ZM12.2322 27.7777H27.7878V16.1111H12.2322V27.7777ZM18.0656 14.1666H21.9544V12.2222H18.0656V14.1666ZM19.0378 22.9166V25.8333H20.9822V22.9166H23.8989V20.9722H20.9822V18.0555H19.0378V20.9722H16.1211V22.9166H19.0378Z",
    fill: "#136DEC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHealthSafetyIcon);
export default __webpack_public_path__ + "static/media/health-safety-icon.87e3a1f55eee7359a8c8852b5529417f.svg";
export { ForwardRef as ReactComponent };